import React from 'react';

const NexusShield = ({ className = "w-8 h-8", color = "#2b64af" }) => (
    <svg
        className={className}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
    >
        <defs>
            <style>
                {`.shield-fill { fill: ${color}; fill-rule: evenodd; }`}
            </style>
        </defs>
        <path
            className="shield-fill"
            d="M24.52,7.37c.16-.04.32-.06.48-.06s.32.02.48.06l13.28,3.32v16.5c0,5.28-2.98,10.1-7.7,12.46l-6.05,3.03-6.05-3.03c-4.72-2.36-7.7-7.18-7.7-12.46V10.69l13.28-3.32ZM25,3.39c-.48,0-.96.06-1.43.18l-13.28,3.32c-1.75.44-2.98,2.01-2.98,3.81v16.5c0,6.77,3.82,12.95,9.87,15.98l6.05,3.03c.55.28,1.16.41,1.76.41s1.2-.14,1.76-.41l6.05-3.03c6.05-3.03,9.87-9.21,9.87-15.98V10.69c0-1.8-1.23-3.38-2.98-3.81l-13.28-3.32c-.47-.12-.95-.18-1.43-.18h0ZM20.21,32.14h3.1V13.52h-3.1v18.62ZM27.79,25.9c-.14-.19-.27-.37-.4-.54-.14-.17-.29-.32-.46-.44.17-.11.34-.24.49-.38.15-.15.3-.31.44-.48l5-4.77h-3.83c-.26,0-.47.05-.63.14-.16.1-.31.23-.45.39l-3.19,3.95c-.13.16-.26.27-.38.33-.09.05-.22.07-.37.08v2.07h0c.25,0,.44.03.56.09.12.06.25.18.38.37l4.27,4.87c.13.2.29.34.45.43.17.08.37.12.62.12h2.79l-5.28-6.24Z"
        />
    </svg>
);

export default NexusShield;
